import { useQuery } from "@tanstack/react-query";
import { instance } from "../../axios.config";

export const useProducts = (id) => {
  return useQuery({
    queryKey: ["products", id],
    queryFn: async () => {
      const {
        data: { data },
      } = await instance.get(`menus/${id}`);
      return data;
    },
  });
};

export const useMenus = () => {
  return useQuery({
    queryKey: ["menus"],
    queryFn: async () => {
      const {
        data,
      } = await instance.get("menus");
      return data;
    },
  });
};
